module.exports = __webpack_public_path__ + "static/media/Siggraph.5c15657e.jpg";